module.exports = __webpack_public_path__ + "static/img/10.83b8a8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/10.png
// module id = CVCB
// module chunks = 0